// extracted by mini-css-extract-plugin
export default {"recents_orders":"RecentOrders_recents_orders__oe0RM","section_header":"RecentOrders_section_header__izK9c","title":"RecentOrders_title__P-20b"};